module.exports = __webpack_public_path__ + "img/全渠道信息化建设.3c56c480.png";